import $ from 'jquery'
import ExcelModal from '@/views/parametres/import-excel-modal'
import { EXAMEN_CATEGORIES, libelleCategorieExamen } from '@/utils/examen-categories'
import listesPaginees from '@/api/parametres/_listes-paginees'
import { nouvelleListe, chargerPage, rechercherDiffere } from '@/utils/liste-paginee'

// Ajoute le libellé de catégorie affiché (tableau et impression)
const avecLibelleCategorie = (examens) => (examens || []).map(examen => ({
    ...examen, categorie_libelle: libelleCategorieExamen(examen.categorie)
}))

export default {
    name: 'param-examens',
    components: {
        ExcelModal
    },
    props: [],
    data() {
        return {
            exm_loading: true,
            exm_empty: false,

            fields: [
				{ key: 'examen', label: 'Type examen' }, { key: 'categorie_libelle', label: 'Catégorie' }, { key: 'actions', label: 'Action.s' }
			],
            // Page courante (pagination et recherche côté serveur, données locales au composant)
            examens: nouvelleListe(),

            c_prestation: {
				id: 0,
				libelle: '',
                prix: 0
			},
            is_edit: false,

            save_loading: false,
            save_error: '',
            categories_examens: EXAMEN_CATEGORIES,
            modal_title: 'Nouvel examen',
            exist_error: false,

            to_be_deleted: {
				id: 0,
				libelle: ''
			},
			is_confirm: false,
			del_loading: false,

            is_printing: false,
            filename: '',

            type_admission: '',
            designation: '',
            emit_action: '',
            modal_toggler: true,

            json_fields: {
                'Libellé': 'libelle',
                'Prix': 'prix',
            },

            export_filename: 'Liste_Examens.xls',
            can_print: false,

            exm_loading_percentage: 0,
            can_view_percentage: false,
            exm_refresh_timeout_id: null,
            countdown_seconds_left: 0,
            countdown_interval_id: null,
        }
    },

    computed: {
        types_examens() {
            return avecLibelleCategorie(this.examens.lignes);
        },
    },

    beforeDestroy() {
        if (this.exm_refresh_timeout_id) {
            clearTimeout(this.exm_refresh_timeout_id)
            this.exm_refresh_timeout_id = null
        }

        if (this.countdown_interval_id) {
            clearInterval(this.countdown_interval_id)
            this.countdown_interval_id = null
        }
    },

    mounted() {
        this.fetchListExamens()

        var d = new Date()
        var tmpstamp = d.getHours()+''+d.getMinutes()+''+d.getFullYear()

        this.filename = 'Liste_des_type_examens_'+tmpstamp
    },
    methods: {
        /**
         * Recherche côté serveur après la saisie (retour à la page 1)
         */
        rechercher(liste, charger) {
            rechercherDiffere(liste, charger)
        },

        importExcelFile(type_admission, designation) {
            this.type_admission = type_admission
            this.designation = designation
            this.modal_toggler = (this.modal_toggler)?false:true

            this.emit_action = 'emitListExamen'

            setTimeout(() => {
                $('.excel-modal-'+type_admission).modal('show')
            }, 200);
            
        },

        countdownLoad() {
            const TOTAL_SECONDS = 12 * 60

            if (this.countdown_interval_id) {
                clearInterval(this.countdown_interval_id)
                this.countdown_interval_id = null
            }

            this.countdown_seconds_left = TOTAL_SECONDS
            // Initialize percentage based on full remaining time
            this.exm_loading_percentage = 100

            this.countdown_interval_id = setInterval(() => {
                if (this.countdown_seconds_left > 0) {
                    this.countdown_seconds_left--
                    // Update loading percentage according to remaining time
                    this.exm_loading_percentage = (this.countdown_seconds_left / TOTAL_SECONDS) * 100
                } else {
                    clearInterval(this.countdown_interval_id)
                    this.countdown_interval_id = null
                    this.exm_loading_percentage = 0
                }
            }, 1000)
        },

		refreshListeExamens() {
            this.exm_loading = true
            this.can_view_percentage = true
            if (this.exm_refresh_timeout_id) {
                clearTimeout(this.exm_refresh_timeout_id)
                this.exm_refresh_timeout_id = null
            }

            if (this.examens.total > 0) {
                this.countdown_seconds_left = 0
            }

            if (this.countdown_seconds_left == 0 ) {
                this.can_view_percentage = false
                this.fetchListExamens()
                return
            }

            // Re-fetch then retry after 5s until counts match
            this.fetchListExamens()
            this.exm_refresh_timeout_id = setTimeout(() => {
                this.refreshListeExamens()
            }, 5000)
        },

		loadEmitAction() {
            this.countdownLoad()
            this.refreshListeExamens()
        },

        /**
         * Recharge la page courante (après ajout, modification, suppression, import)
         */
        fetchListExamens() {
            return chargerPage(this.examens, params => listesPaginees.typesExamens(params)).then(() => {
                if (this.examens.chargement) {
                    // Réponse périmée : une requête plus récente est en cours
                    return
                }

                // Catalogue vide (hors recherche) : message « Aucune donnée disponible »
                this.exm_empty = !this.examens.erreur && this.examens.total == 0 && this.examens.q == ''

                if (this.can_view_percentage) {
                    if (this.countdown_seconds_left == 0) {
                        this.exm_loading = false
                    }
                } else {
                    this.exm_loading = false
                }
            })
        },

        edit(data) {
            this.is_edit = true
            this.save_error = ''
            this.exist_error = false

            this.c_prestation = {
                id: data.id,
                libelle: data.nom,
                prix: data.prix,
                categorie: data.categorie || null
            }
            this.modal_title = data.nom
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

		/**
		 * Selectionne la prestation de consultation à supprimer
		 * @param {*} data 
		 */
		remove(data) {
			this.to_be_deleted = {
                id: data.id,
                libelle: data.nom
            }
		},

		/**
		 * Retirer un examen de la liste de demande
		 */
        supprimer() {
            this.del_loading = true;

            let confirm = document.getElementById('cfrm-del-exm');
            let err = 0

            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                err++;
                this.del_loading = false;
            }

            if (err == 0) {
                this.$store.dispatch('deleteTypeExamen', this.to_be_deleted).then((response) => {
                    
                    if (response > 0) {
                        this.successMsg('Type examen supprimé avec succès')
                    }
                    this.del_loading = false;
                    this.is_confirm = false

					this.fetchListExamens();
					this.$refs.del_exm.click()

                    
                })
            }
        },

        addNewExamen() {
            this.is_edit = false
            this.save_error = ''
            this.exist_error = false
            this.modal_title = 'Nouvel examen'

			this.c_prestation = {
				id: 0,
				libelle: '',
                prix: 0,
                categorie: null
			}
        },

        async submit() {
            if (this.save_loading) return
            const isValid = await this.$refs.exm_form.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true
            this.save_error = ''

            this.$store.dispatch("addNewExamen", this.c_prestation).then((response) => {
                this.save_loading = false

                if (response > 0) {
                    this.fetchListExamens()

                    this.$refs.exm_form.reset()
                    this.$refs.add_modal.click()

                    
                } else {
                    this.exist_error = true
                }
            }).catch(error => {
                this.save_loading = false
                const data = error.response && error.response.data
                this.save_error = data && data.errors && data.errors.categorie
                    ? data.errors.categorie[0] : 'Impossible d’enregistrer cet examen. Réessayez.'
            })
        },

        clearError() {
            this.exist_error = false
        },

        successMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

        handleBeforeGenerate() {
            let d = new Date()
            this.export_filename = 'Liste_Examens_'+d.getMilliseconds()+'.xls'
            this.is_exporting = true
        },

        /**
         * Export Excel : la liste complète est chargée au clic
         * (prop `fetch` de export-excel, appelée après before-generate)
         */
        fetchExportExamens() {
            return listesPaginees.typesExamens().then((examens) => {
                const lignes = (examens || []).map(examen => ({
                    'libelle' : examen.nom,
                    'prix' : (examen.prix > 0)?examen.prix:''
                }))

                if (lignes.length == 0) {
                    // Rien à exporter : export-excel s'arrête sans appeler before-finish
                    this.is_exporting = false
                }
                return lignes
            }).catch(() => {
                this.is_exporting = false
                this.errorToast("Impossible de préparer l'export. Merci de réessayer.")
                return []
            })
        },

        printExamen() {
            if (this.is_printing) {
                return
            }
            this.is_printing = true

            // Impression de la liste complète, chargée au clic
            listesPaginees.typesExamens().then((examens) => {
                const data = {
                    data_type: 'examens',
                    prestations: avecLibelleCategorie(examens)
                }
                this.$emit('emitTriggerPrint', data)
            }).catch(() => {
                this.errorToast("Impossible de charger la liste à imprimer. Merci de réessayer.")
            }).finally(() => {
                this.is_printing = false
            })
        }
    }
}
